import React from 'react';
import { subYears, endOfDay } from 'date-fns';
import { DateInput } from '@uhg-abyss/web/ui/DateInput';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';

const MIN_DATE = subYears(new Date(), 12);
const MAX_DATE = endOfDay(new Date());
const minDateObject = dayjs(MIN_DATE);
const maxDateObject = dayjs(MAX_DATE);

export const ClaimCalender = () => {
  return (
    <React.Fragment>
      <DateInput
        id="attestation-claimDate-input"
        model="attestation.claimDate"
        label="Date the claim was submitted"
        descriptorsDisplay="column"
        minimumDate={minDateObject}
        maximumDate={maxDateObject}
        validators={{
          required: 'Please enter date the claim was submitted.',
          validate: {
            isFuture: (v) => {
              const dateObject = dayjs(v);
              return (
                dateObject.isSameOrBefore(maxDateObject) ||
                'You cannot enter a future date.'
              );
            },
            isValid: (v) => {
              const dateObject = dayjs(v);
              return (
                dateObject.isSameOrAfter(minDateObject) ||
                'Please enter a valid date.'
              );
            },
          },
        }}
        data-testid="attestation-claim-submitted"
      />
    </React.Fragment>
  );
};
